import { styled } from '@mui/material';

export const Root = styled('div')(() => ({
  display: 'flex',
  backgroundRepeat: 'no-repeat',
  backgroundSize: '100% auto',
  backgroundPosition: 'top center',
  backgroundAttachment: 'fixed',
  minHeight: '100vh',
}));
